module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Norma Fox Mazer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Norma Fox Mazer (1931–2009) was an acclaimed author best known for her children’s and young adult literature. She earned numerous awards, including the Newbery Honor for "), _c('I', [_vm._v("After the Rain")]), _vm._v(", the Lewis Carroll Shelf Award for "), _c('I', [_vm._v("Dear Bill, Remember Me?")]), _vm._v(", and the Edgar Award for "), _c('I', [_vm._v("Taking Terri Mueller")]), _vm._v(". Mazer was also honored with a National Book Award nomination for "), _c('I', [_vm._v("A Figure of Speech")]), _vm._v(" and inclusion in the notable-book lists of the American Library Association and the "), _c('I', [_vm._v("New York Times")]), _vm._v(", among others.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JEEjKr/tc-custom/9781497650862.jpg?1702840878554",
      "alt": "This image is the cover for the book Babyface"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Babyface\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When Toni’s luck runs out, real life comes calling")]), _c('br'), _c('br'), _vm._v(" Toni and Julie were both born right after their parents moved in next to one another, and the two girls have hardly been separated since. Julie is tall and outspoken and stands up for herself, but really she’s just trying to survive until she turns eighteen so she can move out before her parents’ constant fighting drives her crazy. Meanwhile, Toni, small and shy, has the perfect family: no financial worries and two parents who obviously adore her. Compared to Julie, Toni knows she’s lucky."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But when Julie’s mom moves her family to San Francisco for the summer, Toni faces new challenges. Some changes are fun, like getting to know the cutest boy in school—but some, like discovering that maybe your family isn’t as perfect as you thought, aren’t quite so easy.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0